// src/admin/components/AdminSidebar.jsx
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Store,
  Settings, 
  LogOut,
  CreditCard,
  ListOrdered,
  Gift, // ✅ AJOUTER CETTE ICÔNE
} from "lucide-react";

export default function AdminSidebar() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  const linkClass = ({ isActive }) =>
    `flex items-center px-4 py-3 gap-3 rounded-xl font-semibold transition-all duration-200 text-sm tracking-wide ${
      isActive
        ? "bg-indigo-50 text-indigo-700 shadow-md shadow-indigo-100 ring-2 ring-indigo-100"
        : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
    }`;

  return (
    <aside className="w-64 min-h-screen p-6 bg-white border-r border-gray-200 shadow-xl shadow-gray-200/50">
      
      <div className="mb-10 text-3xl font-black tracking-tight text-gray-900">
        <span className="text-[#f34141] font-extrabold">Souqi</span> Admin
      </div>

      <nav className="space-y-2">
        <NavLink to="/admin" end className={linkClass}>
          <LayoutDashboard size={20} className="text-gray-400 group-hover:text-gray-900"/> Dashboard
        </NavLink>

        <NavLink to="/admin/users" className={linkClass}>
          <Users size={20} className="text-gray-400 group-hover:text-gray-900"/> Utilisateurs
        </NavLink>

        <NavLink to="/admin/merchants" className={linkClass}>
          <Store size={20} className="text-gray-400 group-hover:text-gray-900"/> Marchands
        </NavLink>

        {/* ✅ NOUVEAU LIEN PROMOTIONS */}
        <NavLink to="/admin/promotions" className={linkClass}>
          <Gift size={20} className="text-gray-400 group-hover:text-gray-900"/> Promotions
        </NavLink>

        <NavLink to="/admin/orders" className={linkClass}>
          <ListOrdered size={20} className="text-gray-400 group-hover:text-gray-900"/> Commandes
        </NavLink>

        <NavLink to="/admin/subscriptions" className={linkClass}>
          <CreditCard size={20} className="text-gray-400 group-hover:text-gray-900"/> Paiements abonnements
        </NavLink>

        <NavLink to="/admin/settings" className={linkClass}>
          <Settings size={20} className="text-gray-400 group-hover:text-gray-900"/> Paramètres
        </NavLink>
      </nav>

      <div className="pt-6 mt-10 border-t border-gray-100">
          <button
            onClick={logout}
            className="flex items-center w-full gap-3 px-4 py-3 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50 rounded-xl"
          >
            <LogOut size={20} /> Déconnexion
          </button>
      </div>
    </aside>
  );
}
